import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  HStack,
  useToast,
  useRadioGroup,
  Text,
  Flex,
  Divider,
  Select,
} from "@chakra-ui/react";
import { ITEContext } from "../../../context/ITEContext";
import IconCard from "../../layouts/IconCard";
import Counter from "../../../assets/Counter";
import Picto1 from "./picto3/Picto1.png";
import Picto2 from "./picto2/Picto2.png";
import Picto3 from "./picto3/Picto3.png";
import Picto4 from "./picto3/Picto4.png";
import Picto5 from "./picto3/Picto5.png";
import RadioCardL from "../../layouts/RadioCardL";

const StepThreeITE = ({ onNext, onBack }) => {
  const { formDataITE, setFormDataITE, defaultFormDataITE } = useContext(ITEContext);
  const [isFormValid, setIsFormValid] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const isValid = formDataITE.housePosition && formDataITE.superficieMur;
    setIsFormValid(isValid);
  }, [formDataITE]);

  const handleNextClick = () => {
    if (isFormValid) {
      onNext();
    } else {
      toast({
        title: "Champs manquants",
        description:
          "Veuillez remplir tous les champs obligatoires pour continuer.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handlesuperficieMurChange = (value) => {
    console.log(formDataITE);
    setFormDataITE((prevFormData) => ({
      ...prevFormData,
      superficieMur: value,
    }));
  };

  const handleRadioChange = (name, value) => {
    setFormDataITE((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const {
    getRootProps: housePositionGroupProps,
    getRadioProps: housePositionRadioProps,
  } = useRadioGroup({
    name: "housePosition",
    defaultValue: formDataITE.housePosition,
    onChange: (value) => handleRadioChange("housePosition", value),
  });

  const handleOccupationChange = (nextValue) => {
    setFormDataITE((prevFormData) => ({
      ...prevFormData,
      occupationType: nextValue,
    }));
  };

  const housePositionOptions = [
    { label: "Maison isolee", value: "Maison isolee", icon: Picto3, iconWidth: "30px" },
    { label: "Maison mitoyenne", value: "Maison mitoyenne", icon: Picto4, iconWidth: "35px" },
    { label: "Maison encadree", value: "Maison encadree", icon: Picto5, iconWidth: "40px" },
  ];

  const handleOrientationToitureChange = (name, value) => {
    setFormDataITE((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <Box width="full" px={20}>
      <Box display={"flex"} flexDirection={"row"} justifyContent="space-between" alignItems="center" mb={8}>
        <Box>
          <Heading fontSize={"28px"} mb={1} fontWeight={"510"}>
            Architecture de la maison
          </Heading>
          <Text color="#8C8C8C" fontWeight={"400"} fontSize="20px">
            Décrivez les détails concernant l'architecture de la maison.
          </Text>
        </Box>
        <Button
          w="120px"
          bgColor={"white"}
          color={"#30C9FF"}
          fontWeight={"600"}
          borderRadius={"8px"}
          padding={"8px 16px"}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "30px", md: "40px" }}
        gap="40px"
        borderRadius="8px"
        bg="#FCFDFF"
        justify="center"
        align="center"
        bgColor={"white"}
      >
        <Box display={"flex"} flexDirection={"column"} width="100%" maxW="1200px">
          <Flex justifyContent="center" mb={8} gap={8}>
            <Box textAlign="center" flex="1">
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={3}
              >
                Toiture à Equiper
              </Heading>
              <Text fontSize="17px" fontWeight={"400"} color="#8C8C8C">
                Choisissez la toiture exact
              </Text>
            </Box>
            <Box textAlign="center" flex="1">
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={3}
              >
                Positionnement de la maison
              </Heading>
              <Text fontSize="17px" fontWeight="400" color="#8C8C8C">
                Choisissez le positionnement de la maison
              </Text>
            </Box>
          </Flex>

          <Flex    direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "30px", md: "40px" }}
        gap="40px"
        borderRadius="8px"
        bg="#FCFDFF"
        justify="center"
        align="center"
        bgColor={"white"}>
            <Box display={"flex"} flexDirection={"column"} width="100%" maxW="1200px">
              <Box
                display={"flex"}
                // w="100%"
                h={"251px"}
                flexDirection={"column"}
                alignItems={"center"}
                gap={"10px"}
                borderRadius={"20px"}
                padding={"20px"}
                borderWidth={"1px"}
              >
                <IconCard icon={Picto1}></IconCard>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  color="#8C8C8C"
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Superficie mur à équiper (M2)
                </Text>
                <Counter
                  initialValue={formDataITE.superficieMur}
                  onCountChange={(value) =>
                    setFormDataITE({ ...formDataITE, superficieMur: value })
                  }
                />
              </Box>
            </Box>

            <Divider
              orientation="vertical"
              border={"1px solid"}
              h={"251px"}
              color={"#EAEAEA"}
            />

            <Box flex="1">
              <Stack {...housePositionGroupProps()} direction="column" spacing={4}>
                {housePositionOptions.map((option) => (
                  <RadioCardL
                    iconWidth={option.iconWidth}
                    key={option.value}
                    {...housePositionRadioProps({ value: option.value })}
                    icon={option.icon}
                  >
                    {option.label}
                  </RadioCardL>
                ))}
              </Stack>
            </Box>
          </Flex>
        </Box>
      </Flex>
      <Flex justifyContent="flex-end" mt={6}>
        <Button
          w="120px"
          bgColor="#30C9FF"
          color="#FCFDFF"
          borderRadius="8px"
          padding="8px 16px"
          onClick={handleNextClick}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default StepThreeITE;
